export default __webpack_public_path__ + "static/BAP_2834_rgb_fine-0be85651e1ab53c1e06c5e69a73d0714.jpg";